(() => {
  const TARGET_ID = 'RoaInstance:td698pdmtmi55:o-naturealm';

  const SCRIPTS = [
    {
      id: 'amazon-product-rating-script',
      src: 'https://cdn.elements.amazon/elements/amazon-product-rating/v1.0/web-component.js'
    },
    {
      id: 'amazon-product-reviews-script',
      src: 'https://cdn.elements.amazon/elements/amazon-product-reviews/v1.0/web-component.js'
    }
  ];

  SCRIPTS.forEach(({ id, src }) => {
    if (document.getElementById(id)) {
      return;
    }

    const script = document.createElement('script');

    script.id = id;
    script.type = 'module';
    script.dataset.targetId = TARGET_ID;
    script.src = src;

    document.head.appendChild(script);
  });
})();

// 

const _attachShadow = Element.prototype.attachShadow;
Element.prototype.attachShadow = function(init) {
  return _attachShadow.call(this, { ...init, mode: 'open' });
};

function injectStyles(host) {
  const root = host.shadowRoot;
  if (!root) return;
  if (root.querySelector('#custom-injected-style')) return;
  const style = document.createElement('style');
  style.id = 'custom-injected-style';
  style.textContent = `
  .rating-text.ember-reg { display: none !important; }
  .rating-container { justify-content: center !important; }
  .star-rating { margin-inline: 8px; }
  `;
  root.appendChild(style);
}

function watchShadowRoot(host) {
  // Inject immediately in case it's already rendered
  injectStyles(host);

  const root = host.shadowRoot;
  if (!root) return;

  // Watch inside the shadow root for late rendering
  const observer = new MutationObserver(() => {
    injectStyles(host);
  });

  observer.observe(root, { childList: true, subtree: true });
}

function handleHost(host) {
  if (host.dataset.handled) return;
  host.dataset.handled = 'true';

  if (host.shadowRoot) {
    watchShadowRoot(host);
  } else {
    // Shadow root not attached yet — poll until it is
    const interval = setInterval(() => {
      if (host.shadowRoot) {
        clearInterval(interval);
        watchShadowRoot(host);
      }
    }, 100);
  }
}

// Handle all existing elements
document.querySelectorAll('.amazon-ratings-card amazon-product-rating').forEach(handleHost);

// Watch for new elements added to the DOM
new MutationObserver((mutations) => {
  mutations.forEach(m => {
    m.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.tagName?.toLowerCase() === '.amazon-ratings-card amazon-product-rating') {
        handleHost(node);
      }
      node.querySelectorAll?.('.amazon-ratings-card amazon-product-rating').forEach(handleHost);
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });